<template>
   <div class="color-selector">
      <label v-if="showLabel" class="color-selector__label">{{ $t('generic.form.select-color') }}</label>

      <div class="color-selector__list" data-cy="color-picker">
         <button
            v-for="color in colors"
            :key="color"
            type="button"
            :style="`background-color: ${color}`"
            :class="[`color-selector__list-item`, { '-default': defaultColor === color, '-active': color === modelValue }]"
            :disabled="disabled"
            @click="() => $emit('update:modelValue', color)"
         ></button>
      </div>
   </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';

defineProps({
   colors: { type: Array as PropType<Array<string>>, default: () => [] },
   modelValue: { type: String, default: null },
   name: { type: String, default: 'color' },
   disabled: { type: Boolean, default: false },
   defaultColor: { type: String, default: null },
   showLabel: { type: Boolean, default: true },
});
defineEmits(['update:modelValue']);
</script>

<style lang="scss" scoped>
.color-selector {
   border-radius: var(--nxt-radius-large);
   display: flex;
   align-items: center;
   gap: var(--nxt-gutter-large);

   &__list {
      display: flex;
      flex-wrap: wrap;
      gap: var(--nxt-gutter-small);
   }

   &__list-item {
      padding: 0;
      margin: 0;
      height: toRem(27);
      width: toRem(27);
      border-radius: var(--nxt-radius);
      box-shadow: inset 0 toRem(4) toRem(4) rgba(0, 0, 0, 0.25);

      &.-active {
         border: toRem(2) solid var(--nxt-brand-primary-light);
         box-shadow: unset;
      }

      &.-default {
         position: relative;
         box-shadow: unset;
         overflow: auto;
         &:after {
            content: '';
            position: absolute;
            height: 100%;
            width: toRem(1);
            background-color: var(--state-danger);
            transform: rotate(45deg) translateX(-50%);
            top: 0;
            left: 50%;
         }
      }
   }
}
.color-selector__label {
   white-space: nowrap;
}
</style>
